import React from 'react';
import { atom } from 'recoil';
import { HabitDataDictionary, UserData } from '../data/types';
import { createHabitData, userHabitsExample } from '../data/test';

export const userDataAtom = atom<UserData | undefined>({
    key: 'userState', 
    default: undefined
})

export const habitDataAtom = atom<HabitDataDictionary>({
    key: 'habitState', 
    default: {}
})